import { createItemStorage } from "../../utils/createItemStorage";

export const cancellationSurvey = ({ storage }) => createItemStorage(storage, "cs_v2");
